export const options =
    [
        { value: 'es', label: 'Spanish' },
        { value: 'en', label: 'English' },
        // { value: 'es', label: 'Spanish' },
        { value: 'pt', label: 'Portuguese' }
    ];